import _ from 'lodash';
import RequestContextService from '../RequestContextService.js';
import getBaseUrl from '../getBaseUrl.js';
import getCSRFCookie from './getCSRFCookie.js';
import refreshMicrosoftIdentity from './refreshMicrosoftIdentity.js';

export default async function refreshAuthToken() {
  const baseUrl = getBaseUrl();
  const csrf = getCSRFCookie();
  const requestContext = RequestContextService.get();

  const thirdPartyToken = await refreshMicrosoftIdentity();

  const response = await fetch(`${baseUrl}/authentication-refresh-token`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip',
      'Content-type': 'application/json; charset=UTF-8',
      ...(csrf && { 'X-CSRF-Token': csrf })
    },
    method: 'POST',
    keepalive: true,
    body: JSON.stringify(
      _.omitBy(
        {
          refreshToken: requestContext?.refreshToken,
          thirdPartyToken
        },
        _.isNil
      )
    )
  });

  if (!response.ok) {
    throw Object.assign(
      new Error(`Error while refreshing authToken : ${response.status} ${response.statusText}`),
      { status: response.status }
    );
  }

  const { authToken, authTokenExpirationDate, refreshToken } = await response.json();
  return { authToken, authTokenExpirationDate, refreshToken };
}
